module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('vuetable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "showEdit": true,
      "showDelete": true,
      "tableData": _vm.testData,
      "tableTitle": 'Search results - Data Option Types',
      "fields": [{
        header: 'ID',
        prop: 'id'
      }, {
        header: 'First Name',
        prop: 'firstName'
      }, {
        header: 'Last Name',
        prop: 'lastName'
      }]
    },
    on: {
      "table-delete-request": _vm.handleDelete,
      "table-edit-request": _vm.handleEdit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03b714fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/DataOptionType/DataOptionTypeSearchResults.vue
// module id = 2072
// module chunks = 1